// extracted by mini-css-extract-plugin
export var cardIcon = "_99-5";
export var cardIconUnframed = "_99-9";
export var checkboxCard = "_99-0";
export var checkboxCardSelected = "_99-4";
export var disabled = "_99-2";
export var interactive = "_99-1";
export var outerBorder = "_99-3";
export var spacerMedium = "_99-8";
export var spacerSmall = "_99-7";
export var spacerXsmall = "_99-6";